import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { ResultQueryStyled } from '../../asset/styled/ResultQueryStyled';
import BeforeAuthentication from './before';
import AfterAuthentication from './after';
import {
  checkNoPaperCertify,
  getComYASetting,
  getPDFUploadInfo,
  getResultData,
  resetResultQueryState,
} from './resultQuerySlice';
import { getAlertMessageFunction, isDateInRange } from '../../common/Util';
import AlertContext from '../../context/AlertContext';
import { getCertifyFlag, getCheckMsg, getMagamFlag, getYAPlan } from '../common/commonSlice';
import IframeViewer from '../../components/common/IframeViewer';
import ReviewInProgressAlert from '../main/ReviewInProgressAlert';
import ServiceDisruptionAlert from '../main/ServiceDisruptionAlert';

const ResultQuery = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation('resultQuery');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isRender, setIsRender] = useState(false);
  const {
    alertActions: { alertMessage },
  } = useContext(AlertContext);
  const { resultData, reload } = useSelector(state => state.resultQuery);
  const { isCertify, msgData, isMagam, magamFlag, yaPlan } = useSelector(state => state.common);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [showServiceDisruption, setShowServiceDisruption] = useState(true);

  useEffect(() => {
    const initializeData = async () => {
      await checkedRequiredFiles();
      //결과조회에서는 마감 확인 다시(안전용)
      await dispatch(getMagamFlag()).unwrap();
      //연말정산 스케줄
      await dispatch(getYAPlan());
      setIsRender(true);
    };

    initializeData();
  }, []);

  useEffect(() => {
    if (
      magamFlag === 'L' // && yaPlan && isDateInRange(yaPlan.htmC1SD, yaPlan.htmC1ED)
    ) {
      setShowReviewModal(true);
    }
  }, [magamFlag, yaPlan]);

  useEffect(() => {
    //2. 결과상세 조회
    if (isRender) {
      getInitalData();
    }
  }, [isRender]);

  useEffect(() => {
    if (reload != -1) {
      getInitalData();
    }
  }, [reload]);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getCertifyFlag());
    }
  }, [isAuthenticated]);

  //페이지 나갈때 초기화
  useEffect(() => {
    return () => {
      dispatch(resetResultQueryState());
    };
  }, []);

  const getInitalData = async () => {
    await dispatch(getResultData());
    await dispatch(getCheckMsg());
    await dispatch(getComYASetting());
  };

  const checkedRequiredFiles = async () => {
    try {
      if (isMagam || isCertify) {
        return;
      }
      //전자문서 파일 올렸는지 여부
      const resultPDFUploadInfo = await dispatch(getPDFUploadInfo()).unwrap();
      if (resultPDFUploadInfo.resultCode == '1') {
        //필요한 증빙서류
        noPaperCertify();
      } else {
        if (resultPDFUploadInfo.resultCode == '2') {
          //필요한 통합
          alertMessage(t('alertMessage2'));
        }
        if (resultPDFUploadInfo.resultCode == '3' || resultPDFUploadInfo.resultCode == '5') {
          //필요한 상세
          alertMessage(t('alertMessage3'));
        }
        if (resultPDFUploadInfo.resultCode == '4') {
          //전자문서(PDF) 파일을 업로드 해주세요.
          alertMessage(t('alertMessage4'));
        }
        navigate('/eDocuments');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const noPaperCertify = async () => {
    try {
      const result = await dispatch(checkNoPaperCertify()).unwrap();
      const { resultCode } = result;
      if (resultCode === '0') {
        //필요한 증빙서류~~
        alertMessage(t('alertMessage1'));
        navigate('/evidenceDocuments');
      } else {
        setIsRender(true);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleAuthentication = () => {
    setIsAuthenticated(true);
  };

  if (!isRender) return null;

  return (
    <ResultQueryStyled>
      {isCertify || resultData?.htmViewMagam == '1' ? (
        //서명후
        <AfterAuthentication />
      ) : (
        //서명전
        <BeforeAuthentication {...{ handleAuthentication }} />
      )}

      <IframeViewer />
      <ReviewInProgressAlert isOpen={showReviewModal} onClose={() => setShowReviewModal(false)} />
      {/* {showServiceDisruption && (
        <ServiceDisruptionAlert onClose={() => setShowServiceDisruption(false)} />
      )} */}
    </ResultQueryStyled>
  );
};

export default ResultQuery;
